export const Rates = {
  FindBankRegressionData: {
    Data: {}
  }
}
